import { useEffect, useState } from "react";

export default function useDocumentElementById(elementId) {
    const [element, setElement] = useState(null);

    useEffect(() => {
        const updateElement = () => {
            setElement(document.getElementById(elementId));
        };

        updateElement();

        if (!document.body) {
            return undefined;
        }

        const observer = new MutationObserver(() => {
            updateElement();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });

        return () => {
            observer.disconnect();
        };
    }, [elementId]);

    return element;
}
